import { gql } from '@apollo/client'

export default gql(`
    mutation updateConfigGroupSchema($id: ID! $name: String $streams: [CreateStreamSchemaInput]! $fields: [CreateFieldInput] $version: String!) {
        updateConfigGroupSchema(
            input: {
                id: $id
                name: $name
                fields: $fields
                streams: $streams
                version: $version
            }
        ) {
            id
            name
            usedCount
            version
            streams{
                id
                levels {
                    id
                    name
                    fields{
                        name
                        value
                        isRequired
                        type
                    }
                }
            }
            fields{
                name
                value
                isRequired
                type
            }
        }
    }`
)
